import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const AddFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22.0703C17.4667 22.0703 22 17.5437 22 12.0703C22 6.5969 17.458 2.07031 11.9869 2.07031C6.5207 2.07031 2 6.5969 2 12.0703C2 17.5437 6.52941 22.0703 11.9957 22.0703ZM7.25726 12.079C7.25726 11.6266 7.57981 11.3087 8.03207 11.3087H11.247V8.09239C11.247 7.64383 11.5473 7.32595 11.983 7.32595C12.4353 7.32595 12.753 7.6399 12.753 8.09239V11.3087H15.9766C16.4202 11.3087 16.7427 11.6266 16.7427 12.079C16.7427 12.5149 16.4163 12.8241 15.9766 12.8241H12.753V16.0404C12.753 16.4929 12.4353 16.8068 11.983 16.8068C11.5473 16.8068 11.247 16.4802 11.247 16.0404V12.8241H8.03207C7.58372 12.8241 7.25726 12.5149 7.25726 12.079Z"
        fill={color}
      />
    </svg>
  );
};

export { AddFilledSvg };
